export default __webpack_public_path__ + "static/media/classtrack_f1.a3da0260.png";